var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccesRadio({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 88,
    viewBox: "0 0 90 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Not Found illustration"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.7039 87.0474C67.4784 87.0474 86.7515 67.7743 86.7515 43.9998C86.7515 20.2252 67.4784 0.952148 43.7039 0.952148C19.9293 0.952148 0.65625 20.2252 0.65625 43.9998C0.65625 67.7743 19.9293 87.0474 43.7039 87.0474Z",
    fill: "url(#paint0_linear_2175_6046)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 18.4508,
    y: 17.1158,
    width: 53.0165,
    height: 53.0165
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3.13px)",
      clipPath: "url(#bgblur_0_2175_6046_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    "data-figma-bg-blur-radius": 6.25823,
    d: "M44.959 63.874C56.1428 63.874 65.209 54.8078 65.209 43.624C65.209 32.4403 56.1428 23.374 44.959 23.374C33.7752 23.374 24.709 32.4403 24.709 43.624C24.709 54.8078 33.7752 63.874 44.959 63.874Z",
    fill: "url(#paint1_linear_2175_6046)",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9761 43.0076C67.9761 55.7839 57.6188 66.1411 44.8425 66.1411C32.0662 66.1411 21.709 55.7839 21.709 43.0076C21.709 30.2313 32.0662 19.874 44.8425 19.874C57.6188 19.874 67.9761 30.2313 67.9761 43.0076ZM64.4276 43.0065C64.4276 53.8231 55.659 62.5916 44.8425 62.5916C34.0259 62.5916 25.2573 53.8231 25.2573 43.0065C25.2573 32.1899 34.0259 23.4214 44.8425 23.4214C55.659 23.4214 64.4276 32.1899 64.4276 43.0065Z",
    fill: "url(#paint2_linear_2175_6046)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 18.9996,
    y: 17.1636,
    width: 51.6869,
    height: 51.6869
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3.13px)",
      clipPath: "url(#bgblur_1_2175_6046_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    "data-figma-bg-blur-radius": 6.25823,
    d: "M44.8429 62.5921C55.6595 62.5921 64.4281 53.8236 64.4281 43.007C64.4281 32.1904 55.6595 23.4219 44.8429 23.4219C34.0264 23.4219 25.2578 32.1904 25.2578 43.007C25.2578 53.8236 34.0264 62.5921 44.8429 62.5921Z",
    fill: "url(#paint3_linear_2175_6046)",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9143 52.2771C41.3126 52.2971 40.7295 52.0669 40.3038 51.6412L34.8461 46.1835C33.9966 45.334 33.9966 43.9568 34.8461 43.1073C35.6955 42.2579 37.0728 42.2579 37.9222 43.1073L41.7359 46.921L52.9396 34.1169C53.7306 33.2128 55.1048 33.1212 56.0089 33.9122C56.913 34.7033 57.0046 36.0775 56.2135 36.9816L43.4789 51.5355C43.0824 51.9886 42.5159 52.2571 41.9143 52.2771Z",
    fill: "url(#paint4_linear_2175_6046)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M80.8277 56.0494C81.022 55.2447 82.1665 55.2447 82.3608 56.0494L83.0145 58.7576C83.0839 59.0451 83.3084 59.2696 83.596 59.339L86.3042 59.9928C87.1088 60.187 87.1088 61.3316 86.3042 61.5258L83.596 62.1795C83.3084 62.2489 83.0839 62.4735 83.0145 62.761L82.3608 65.4692C82.1665 66.2739 81.022 66.2739 80.8277 65.4692L80.174 62.761C80.1046 62.4735 79.8801 62.2489 79.5925 62.1795L76.8843 61.5258C76.0797 61.3316 76.0797 60.187 76.8843 59.9928L79.5925 59.339C79.8801 59.2696 80.1046 59.0451 80.174 58.7576L80.8277 56.0494Z",
    fill: "url(#paint5_linear_2175_6046)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Star 3",
    d: "M16.1838 16.9673C16.3042 16.4687 17.0132 16.4687 17.1336 16.9673L17.5386 18.6451C17.5816 18.8233 17.7207 18.9623 17.8989 19.0054L19.5767 19.4104C20.0752 19.5307 20.0752 20.2398 19.5767 20.3601L17.8989 20.7652C17.7207 20.8082 17.5816 20.9473 17.5386 21.1254L17.1336 22.8033C17.0132 23.3018 16.3042 23.3018 16.1838 22.8033L15.7788 21.1254C15.7358 20.9473 15.5967 20.8082 15.4185 20.7652L13.7407 20.3601C13.2422 20.2398 13.2422 19.5307 13.7407 19.4104L15.4185 19.0054C15.5967 18.9623 15.7358 18.8233 15.7788 18.6451L16.1838 16.9673Z",
    fill: "url(#paint6_linear_2175_6046)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Star 2",
    d: "M20.512 69.8978C20.7504 68.9101 22.1554 68.9101 22.3938 69.8978L23.1963 73.2222C23.2815 73.5752 23.5571 73.8508 23.9101 73.936L27.2345 74.7385C28.2222 74.977 28.2222 76.3819 27.2345 76.6204L23.9101 77.4229C23.5571 77.5081 23.2815 77.7837 23.1963 78.1366L22.3938 81.461C22.1554 82.4488 20.7504 82.4488 20.512 81.461L19.7095 78.1366C19.6243 77.7837 19.3487 77.5081 18.9957 77.4229L15.6713 76.6204C14.6835 76.3819 14.6835 74.977 15.6713 74.7385L18.9957 73.936C19.3487 73.8508 19.6243 73.5752 19.7095 73.2222L20.512 69.8978Z",
    fill: "url(#paint7_linear_2175_6046)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 59 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0733 69.6141C31.7991 69.6141 32.3875 69.0257 32.3875 68.2999C32.3875 67.574 31.7991 66.9857 31.0733 66.9857C30.3475 66.9857 29.7591 67.574 29.7591 68.2999C29.7591 69.0257 30.3475 69.6141 31.0733 69.6141ZM31.0733 70.5997C32.3435 70.5997 33.3732 69.57 33.3732 68.2999C33.3732 67.0297 32.3435 66 31.0733 66C29.8031 66 28.7734 67.0297 28.7734 68.2999C28.7734 69.57 29.8031 70.5997 31.0733 70.5997Z",
    fill: "url(#paint8_linear_2175_6046)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2",
    d: "M74.7587 42.6889C75.2545 42.5886 75.673 43.0627 75.5119 43.5422L74.4246 46.7789C74.2635 47.2584 73.6438 47.3837 73.309 47.0045L71.0496 44.4445C70.7149 44.0652 70.9163 43.4659 71.4121 43.3656L74.7587 42.6889Z",
    fill: "url(#paint9_linear_2175_6046)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3",
    d: "M13.3442 27.9516C14.0421 27.9773 14.4505 28.7489 14.0793 29.3405L11.5735 33.3337C11.2023 33.9253 10.3298 33.8932 10.0031 33.2759L7.79778 29.1092C7.47106 28.4919 7.9351 27.7524 8.63304 27.7781L13.3442 27.9516Z",
    fill: "url(#paint10_linear_2175_6046)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 60 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9922 39.4881C84.7181 39.4881 85.3065 38.8997 85.3065 38.1739C85.3065 37.4481 84.7181 36.8597 83.9922 36.8597C83.2664 36.8597 82.678 37.4481 82.678 38.1739C82.678 38.8997 83.2664 39.4881 83.9922 39.4881ZM83.9922 40.4738C85.2624 40.4738 86.2921 39.4441 86.2921 38.1739C86.2921 36.9037 85.2624 35.874 83.9922 35.874C82.7221 35.874 81.6924 36.9037 81.6924 38.1739C81.6924 39.4441 82.7221 40.4738 83.9922 40.4738Z",
    fill: "url(#paint11_linear_2175_6046)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_2175_6046_clip_path",
    transform: "translate(-18.4508 -17.1158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.959 63.874C56.1428 63.874 65.209 54.8078 65.209 43.624C65.209 32.4403 56.1428 23.374 44.959 23.374C33.7752 23.374 24.709 32.4403 24.709 43.624C24.709 54.8078 33.7752 63.874 44.959 63.874Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_2175_6046_clip_path",
    transform: "translate(-18.9996 -17.1636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8429 62.5921C55.6595 62.5921 64.4281 53.8236 64.4281 43.007C64.4281 32.1904 55.6595 23.4219 44.8429 23.4219C34.0264 23.4219 25.2578 32.1904 25.2578 43.007C25.2578 53.8236 34.0264 62.5921 44.8429 62.5921Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2175_6046",
    x1: 43.372,
    y1: -13.0652,
    x2: 44.2539,
    y2: 138.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-bg-base)",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-brand-400)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2175_6046",
    x1: 44.959,
    y1: 23.374,
    x2: 65.3643,
    y2: 76.3236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-bg-base)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-text-primary-alt)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2175_6046",
    x1: 21.6566,
    y1: 30.5518,
    x2: 68.2276,
    y2: 30.8542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-brand-400)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-brand-550)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2175_6046",
    x1: 44.8429,
    y1: 23.4219,
    x2: 64.5783,
    y2: 74.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-bg-base)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-text-primary-alt)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2175_6046",
    x1: 51.7426,
    y1: 33.4018,
    x2: 51.5685,
    y2: 52.3426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-brand-400)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-brand-550)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2175_6046",
    x1: 73.6911,
    y1: 56.5136,
    x2: 89.5653,
    y2: 56.6167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-brand-400)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-brand-550)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2175_6046",
    x1: 11.7624,
    y1: 17.2549,
    x2: 21.5971,
    y2: 17.3188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-brand-400)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-brand-550)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2175_6046",
    x1: 11.7515,
    y1: 70.4678,
    x2: 31.2376,
    y2: 70.5943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-brand-400)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-brand-550)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2175_6046",
    x1: 28.7682,
    y1: 67.0616,
    x2: 33.3982,
    y2: 67.0916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-brand-400)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-brand-550)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2175_6046",
    x1: 72.5583,
    y1: 40.9979,
    x2: 76.9029,
    y2: 45.9853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-brand-400)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-brand-550)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2175_6046",
    x1: 10.937,
    y1: 24.9704,
    x2: 15.1567,
    y2: 33.0697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-brand-400)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-brand-550)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2175_6046",
    x1: 81.6872,
    y1: 36.9356,
    x2: 86.3171,
    y2: 36.9656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-brand-400)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-brand-550)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccesRadio);
export default __webpack_public_path__ + "static/media/succes-radio.2237125169ddd71459bab4342079dd7b.svg";
export { ForwardRef as ReactComponent };